import script from "./AppPrivacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppPrivacy.vue?vue&type=script&lang=ts&setup=true"

import "./AppPrivacy.vue?vue&type=style&index=0&id=86585e90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86585e90"]])

export default __exports__